const getFilters = (query) => {
  const {
    q,
    categories,
    arms,
    lat,
    lon,
    homeDelivery,
    distance,
    // postalCode,
    // city,
    addressLabel,
    limit,
    page,
    sort,
    order,
    minPrice,
    maxPrice,
    brand,
    brands,
    allc,
    countries,
    ltype,
  } = query
  let filters = { q, lat, lon, addressLabel, ltype, sort, order, brand, brands }

  if (homeDelivery) filters.homeDelivery = homeDelivery === 'true'
  if (page) filters.page = parseInt(page)
  if (limit) filters.limit = parseInt(limit)
  if (distance) filters.distance = parseInt(distance)
  if (minPrice) filters.minPrice = parseInt(minPrice)
  if (maxPrice) filters.maxPrice = parseInt(maxPrice)
  if (brands) filters.brands = parseInt(brands)
  if (allc) filters.allc = !!allc
  if (countries) filters.countries = countries.split(',')

  filters.categories = (categories && typeof categories === 'array') ? categories.split(',') : [null]

  if (arms) {
    filters.arms = {}
    arms.split(',').forEach(a => {
      filters.arms[a] = true
    })
  }
  // this.address = { postalCode, city }
  // if (postalCode !== undefined && city !== undefined) {
  //   this.searchLocation = city + ' - ' + postalCode
  //   this.setLocation({ city, postalCode, lat, lon })
  // }
  return filters
}

const serializedFilters = (filters) => {
  let f = { ...filters }
  if (f.arms)
    f.arms = Object.keys(f.arms).filter(key => f.arms[key] === true).join()

  if (f.categories) {
    f.categories = f.categories.join()
  }

  if (f.countries) {
    f.countries = f.countries.join()
  }

  if (f.page && f.page === 1) {
    delete f.page
  }

  if (f.distance && (!f.lat || !f.lon)) {
    delete f.distance
  }

  // Remove empty filter
  for (const filter in f) {
    if (f[filter] === undefined || f[filter] === null || f[filter] === '') {
      delete f[filter]
    }
  }
  return f
}

export {
  serializedFilters,
  getFilters,
}

export default getFilters
